import type { ReactNode } from "react";
import type { Locale } from "../i18n/texts";
import type { LegalDocumentId } from "../legal/legalDocuments";
import { BheliLogo } from "../ui/brand";
import { LegalNotice } from "./LegalNotice";

/**
 * Marco de los flujos públicos y de autenticación (AuthLayout.razor del portal actual): sin navegación del portal y con
 * el lockup vertical único de la marca; las páginas no repiten logos. Las páginas legales pasan `legal` para que el pie
 * enlace en su idioma y marque el documento abierto.
 */
export function AuthLayout({
  children,
  legal,
}: {
  children: ReactNode;
  legal?: { locale: Locale; current?: LegalDocumentId };
}) {
  return (
    <main id="main" tabIndex={-1} className="auth-shell">
      <div className="auth-brand">
        <BheliLogo variant="vertical" size={48} theme="auto" />
      </div>
      {children}
      <LegalNotice locale={legal?.locale} current={legal?.current} />
    </main>
  );
}
